import { Fragment, useEffect, useState } from "react";

import i18next from "i18next";
import { useSelector } from "react-redux";

import { getFilterRecommendations, getSortingRecommendations } from "../../../utils";

import QuickPicksComponent from "../QuickPicksComponent";
import RecommendationComponent from "../RecommendationComponent";

import { ShowMoreButton, ShowMoreButtonBlock, Wrapper } from "./style";
import NotFoundRecommendationsComponent from "../NotFoundRecommendationsComponent";

const ResultsComponent = () => {
  const { t } = i18next;
  const { recommendations } = useSelector(state => state.resultData);
  const { filterParams } = useSelector(state => state.resultFilters);
  const { currency } = useSelector(state => state.appConfigs);

  const [page, setPage] = useState(1);
  // rec_id рекомендации, к которой нужно прокрутить после клика по «быстрому выбору»
  // (список постраничный — сначала открываем нужную страницу, потом скроллим)
  const [scrollTarget, setScrollTarget] = useState(null);

  useEffect(() => {
    setPage(1);
  }, [filterParams]);

  const filterRecommendation = getFilterRecommendations(filterParams, recommendations, currency);
  const sortRecommendation = getSortingRecommendations(filterParams, filterRecommendation, currency);

  useEffect(() => {
    if (!scrollTarget) return;
    const element = document.getElementById(`rec-${scrollTarget}`);
    if (!element) return;
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.style.transition = "box-shadow .3s ease";
    element.style.boxShadow = "0 0 0 3px rgba(230, 57, 70, 0.6)";
    const timer = setTimeout(() => {
      element.style.boxShadow = "";
    }, 1800);
    setScrollTarget(null);
    return () => clearTimeout(timer);
  }, [scrollTarget, page]);

  const handleQuickPick = recommendation => {
    const index = sortRecommendation.findIndex(rec => rec.rec_id === recommendation.rec_id);
    if (index < 0) return;
    const neededPage = Math.floor(index / 10) + 1;
    if (neededPage > page) setPage(neededPage);
    setScrollTarget(recommendation.rec_id);
  };

  const renderResultBlock = () => {
    if (sortRecommendation.length === 0) {
      return <NotFoundRecommendationsComponent byFilters={true} />;
    }


    const fullList = sortRecommendation.map((rec, ind) => renderRecommendation(rec, ind));
    const list = fullList.filter(item => item.key < page * 10);

    return (
      <div>
        <QuickPicksComponent recommendations={sortRecommendation} currency={currency} onPick={handleQuickPick} />
        {list}
        {list.length < fullList.length ? (
          <ShowMoreButtonBlock>
            <ShowMoreButton onClick={() => setPage(prev => prev + 1)}>{t("show_more")}</ShowMoreButton>
          </ShowMoreButtonBlock>
        ) : null}
      </div>
    );
  };

  const renderRecommendation = (recommendation, index) => {
    return (
      <Fragment key={index}>
        <RecommendationComponent recommendation={recommendation} index={index} />
      </Fragment>
    );
  };

  return <Wrapper>{renderResultBlock()}</Wrapper>;
};

export default ResultsComponent;
